import { PRIVATE_API_ROUTES } from "../constants";
import Http from "./http-service";

import {
  downloadReports,
  getLocalizedMessage,
  hideLoaderShowErrorMsg,
} from "../UtilityFunctions/utils";
import { showNotification } from "../UtilityFunctions/notification";
import {
  getUserById,
  getUserList as getUserListAction,
} from "../globalContext/Users/userActions";
import { setLoading } from "../globalContext/globalLoader/globalLoaderAction";

class UserService {
  static async getUsersList({ dispatch, params, intl, loaderDispatch }) {
    loaderDispatch(setLoading(true));
    return Http.get(PRIVATE_API_ROUTES.USER_LISTING, params)
      .then(({ data }) => {
        loaderDispatch(setLoading(false));
        dispatch(getUserListAction(data?.data));
      })
      .catch(() => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
      });
  }

  static async blockUnblockUser({ body, intl, userId, name }) {
    return Http.put(PRIVATE_API_ROUTES.USER_BLOCK_UNBLOCK(userId), body)
      .then(({ data }) => {
        showNotification(
          "success",
          "Success",
          getLocalizedMessage(intl, "userManagement.blockUnblockMsg", {
            blockOrUnblock: body.isActive ? "unblocked" : "blocked",
            name,
          })
        );
        return Promise.resolve(data);
      })
      .catch((err) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      });
  }

  static async getUserDetailsById(dispatch, loaderDispatch, userId, intl) {
    loaderDispatch(setLoading(true));
    return Http.get(`${PRIVATE_API_ROUTES.CREATE_USER}/${userId}`)
      .then((res) => {
        loaderDispatch(setLoading(false));
        if (dispatch) {
          dispatch(getUserById(res?.data?.data));
        } else {
          return Promise.resolve(res?.data?.data?.result?.[0]);
        }
      })
      .catch((error) => {
        loaderDispatch(setLoading(false));
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(error);
      });
  }

  static async getDownloadUsersReports({ params, intl, loaderDispatch }) {
    loaderDispatch(setLoading(true));
    return Http.get(
      PRIVATE_API_ROUTES.DOWNLOAD_USER_REPORTS,
      params,
      () => {}, //NOSONAR
      "blob"
    )
      .then((response) => {
        loaderDispatch(setLoading(false));
        downloadReports(response);
      })
      .catch(() => {
        // NOSONAR
        hideLoaderShowErrorMsg({ loaderDispatch, intl, setLoading });
      });
  }
}

export default UserService;
